import React from 'react';
import { cn } from '@/lib/utils';

interface Props {
  percentage: number;
  size?: 'sm' | 'md' | 'lg';
  showLabel?: boolean;
}

export function ProfileCompletionBadge({ percentage, size = 'md', showLabel = true }: Props) {
  const color = percentage >= 80 ? 'text-[hsl(var(--success))]' : percentage >= 50 ? 'text-[hsl(var(--warning))]' : 'text-[hsl(var(--destructive))]';
  const sizeClasses = {
    sm: 'h-8 w-8 text-xs',
    md: 'h-12 w-12 text-sm',
    lg: 'h-16 w-16 text-base',
  };

  const radius = size === 'sm' ? 12 : size === 'md' ? 18 : 24;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference - (percentage / 100) * circumference;

  return (
    <div className="flex items-center gap-2">
      <div className={cn('relative flex items-center justify-center', sizeClasses[size])}>
        <svg className="absolute inset-0 -rotate-90" viewBox={`0 0 ${(radius + 3) * 2} ${(radius + 3) * 2}`}>
          <circle cx={radius + 3} cy={radius + 3} r={radius} fill="none" stroke="hsl(var(--muted))" strokeWidth="3" />
          <circle cx={radius + 3} cy={radius + 3} r={radius} fill="none" stroke="currentColor" strokeWidth="3"
            strokeDasharray={circumference} strokeDashoffset={offset} strokeLinecap="round"
            className={cn(color, 'transition-all duration-700')} />
        </svg>
        <span className={cn('font-bold', color)}>{percentage}%</span>
      </div>
      {showLabel && <span className="text-sm text-muted-foreground">Profile Complete</span>}
    </div>
  );
}
